import { SNoop } from '@obvious.tech/util/validation/schemas'
import { defineEntity } from '../../defineEntity'
import { IDiagram } from '@obvious.tech/constellation'

export const Diagram = defineEntity('Diagram', {
  endpoint: 'flow/api/Diagram',
  schema: SNoop<IDiagram>(),
})
